// Scent finder wizard (v2, 19 Sep 2026). One question per screen -> "Your perfume" (best match),
// "Or try" (second-best, a different perfume, any collection) and the Discovery Set line.
// ONE file for the static site and the theme (theme/assets/mz-scent-wizard.js is a byte-identical copy).
// Motion + card language mirror the Play-to-win popup (game.js): perfume-colour card,
// Six Caps display type, white CTA with perfume-colour ink.
// Facts (role, arc, price, link) are copied from each PDP; on Shopify, window.MZ.products
// (theme.liquid) supplies the live url, image and price instead.
// Scoring is a plain additive table: every answer adds points to the perfumes it fits;
// highest total wins, next highest is the alternative, ties go to list order.
//
// Mount: the page shell #sw (scent-finder page) boots itself. Anywhere else:
//   window.MZFinder.open({ mode: 'claim', onPick: function (handle, rank) {}, onDiscovery: function () {} })
// window.MZFinder.info(slug) / .slugs expose the ten perfumes' facts (the game's bottle grid reads them).
// renders the finder into an overlay. mode 'claim' turns both CTAs into "Choose this" buttons
// (no navigation) and the Discovery line into a button; the overlay closes after a pick.
// Without 'claim' the CTAs are links; the callbacks still fire, then the link navigates.
(function () {
  var E = 'La Collezione Epos', O = 'La Collezione Oud', C = 'La Collezione Cristallo';
  // slug: [name, collection, role, arc, price, accent, pdp]
  var P = {
    'midsea-murmur':    ['Midsea Murmur', E, 'The Daily Signature', ['Fresh Marine', 'Woody Aromatic'], '₹3,519 · 60 ML', 'midsea', 'pdp-hero-midsea-murmur.html'],
    'divine-dilemma':   ['Divine Dilemma', E, 'The Compliment Getter', ['Bright Citrus', 'Amber Musk'], '₹3,499 · 60 ML', 'divine', 'pdp-hero-divine-dilemma.html'],
    'crown-cardinal':   ['Crown Cardinal', E, 'The Authority Stamp', ['Fruity Citrus', 'Spiced Royal Oud'], '₹3,499 · 60 ML', 'crown', 'pdp-hero-crown-cardinal.html'],
    'black-sunset':     ['Black Sunset', E, 'The Last Impression', ['Aromatic Spice', 'Smoky Animalic Oud'], '₹3,589 · 60 ML', 'bsunset', 'pdp-hero-black-sunset.html'],
    'rich-reverie':     ['Rich Reverie', E, 'The Night Magnet', ['Rich Fruity Coffee', 'Creamy Vanilla Gourmand'], '₹3,419 · 60 ML', 'rich', 'pdp-hero-rich-reverie.html'],
    'rose-oclock':      ["Rose O'Clock", E, 'The Romantic Signature', ['Bright Fruit', 'Blooming Rose'], '₹3,659 · 60 ML', 'rose', 'pdp-hero.html'],
    'oud-of-the-ocean': ['Oud of the Ocean', O, 'The Daylight Oud', ['Saffron · Mint · Marine Notes', 'Oud · Tobacco & Musk · Vetiver & Moss'], '₹1,499 · 50 ML', 'ocean', 'pdp-hero-oud-of-the-ocean.html'],
    'oud-of-the-storm': ['Oud of the Storm', O, 'The Last Word', ['Saffron · Mandarin · Frankincense', 'Oud · Leather & Musk · Vetiver & Moss'], '₹1,899 · 50 ML', 'storm', 'pdp-hero-oud-of-the-storm.html'],
    'saharan-spice':    ['Saharan Spice', C, 'The Golden Hour', ['Sicilian Bergamot · Pink Pepper', 'Leather · Musk'], '₹1,499 · 50 ML', 'saharan', 'pdp-hero-saharan-spice.html'],
    'silk-blush':       ['Silk Blush', C, 'The Second Skin', ['Italian Lemon · Turkish Rose', 'Cedarwood · Sugar'], '₹1,499 · 50 ML', 'silk', 'pdp-hero-silk-blush.html']
  };
  var SLUGS = Object.keys(P);
  var EPOS = SLUGS.slice(0, 6), CLASSIC = SLUGS.slice(6);
  function all(list, n) { var o = {}; list.forEach(function (s) { o[s] = n; }); return o; }

  // [key, question, [[value, label, short reason, {slug: points}]]]
  var Q = [
    ['when', 'When does this scent belong to you?', [
      ['every', 'Every day, as my signature - the one I reach for without thinking.', 'every day',
        { 'midsea-murmur': 3, 'divine-dilemma': 2, 'oud-of-the-ocean': 2, 'silk-blush': 2, 'saharan-spice': 1 }],
      ['night', 'At night - dinners, evenings, the hours after dark.', 'after dark',
        { 'black-sunset': 3, 'rich-reverie': 3, 'oud-of-the-storm': 2, 'crown-cardinal': 1, 'rose-oclock': 1, 'saharan-spice': 1 }],
      ['room', 'For the room that matters - work, formal, the moments I need to be taken seriously.', 'the room that matters',
        { 'crown-cardinal': 3, 'oud-of-the-storm': 2, 'saharan-spice': 2, 'midsea-murmur': 1, 'oud-of-the-ocean': 1, 'black-sunset': 1, 'divine-dilemma': 1 }],
      ['romance', 'For romance - closeness, warmth, being drawn nearer.', 'romance',
        { 'rose-oclock': 3, 'rich-reverie': 2, 'silk-blush': 2, 'divine-dilemma': 1 }]
    ]],
    ['feel', 'What should it feel like on you?', [
      ['fresh', 'Fresh and clean - air, citrus, water.', 'fresh and clean',
        { 'midsea-murmur': 3, 'divine-dilemma': 2, 'oud-of-the-ocean': 2, 'crown-cardinal': 1 }],
      ['warm', 'Warm and spiced - depth, dry spice, wood.', 'warm and spiced',
        { 'saharan-spice': 3, 'crown-cardinal': 2, 'divine-dilemma': 1, 'midsea-murmur': 1, 'black-sunset': 1, 'oud-of-the-storm': 1 }],
      ['sweet', 'Sweet and enveloping - coffee, vanilla, something to sink into.', 'sweet and enveloping',
        { 'rich-reverie': 3, 'silk-blush': 2, 'rose-oclock': 1 }],
      ['floral', 'Floral - a living bloom, soft or full.', 'floral',
        { 'rose-oclock': 3, 'silk-blush': 2, 'rich-reverie': 1 }],
      ['dark', 'Dark and smoky - oud, resins, shadow.', 'dark and smoky',
        { 'black-sunset': 3, 'oud-of-the-storm': 3, 'crown-cardinal': 1, 'oud-of-the-ocean': 1 }]
    ]],
    ['room', 'How much room should it take?', [
      ['close', 'Close and quiet - for me and the person beside me, not the whole floor.', 'close and quiet',
        { 'silk-blush': 3, 'midsea-murmur': 2, 'saharan-spice': 1, 'divine-dilemma': 1, 'rose-oclock': 1, 'oud-of-the-ocean': 1 }],
      ['present', 'Present - I want it noticed.', 'present',
        { 'divine-dilemma': 3, 'crown-cardinal': 2, 'rose-oclock': 2, 'rich-reverie': 2, 'oud-of-the-ocean': 2, 'saharan-spice': 2, 'midsea-murmur': 1 }],
      ['statement', 'A statement - I want it to arrive before I do.', 'a statement',
        { 'oud-of-the-storm': 3, 'black-sunset': 3, 'crown-cardinal': 2, 'rich-reverie': 1 }]
    ]],
    ['arc', 'Should it change as the hours pass?', [
      ['dyadic', 'Yes - open as one scent, land as another. That is Dyadic Olfaction.', 'a scent that turns', all(EPOS, 2)],
      ['classic', 'No - one character, deepening as it wears.', 'one deepening character', all(CLASSIC, 2)],
      ['either', 'Either - show me the best fit.', '', {}]
    ]],
    ['new', 'Is this your first time in the house?', [
      ['yes', 'Yes, this is my first Monzzaro.', '', {}],
      ['no', 'No, I already wear the house.', '', {}]
    ]]
  ];

  // answers: array of option indexes, one per question -> [best, alternative] (always two different slugs)
  function rank(answers) {
    var t = {};
    SLUGS.forEach(function (s) { t[s] = 0; });
    answers.forEach(function (a, i) {
      var pts = Q[i][2][a][3];
      for (var s in pts) t[s] += pts[s];
    });
    return SLUGS.slice().sort(function (a, b) { return t[b] - t[a] || SLUGS.indexOf(a) - SLUGS.indexOf(b); }).slice(0, 2);
  }
  window.mzScentWizard = { P: P, Q: Q, rank: rank };   // ponytail: exposed for the path check
  if (typeof document === 'undefined') return;

  var DISCO = 'Still not sure? Start with the Discovery Set: all six Epos perfumes, 5 ml each, ₹1,949.';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ponytail: the component CSS lives here so the finder looks the same on its page, on a PDP
  // overlay and in the theme without a third copy in site.css. Page-only layout stays on the page.
  var CSS =
'.sw-card{--sw-bg:#1A1A1B;--sw-ink:#FFF}' +          // dark: Faiz's ground #1A1A1B, white ink (21 Sep)
'html.mzlight .sw-card{--sw-bg:#FFF;--sw-ink:#1A1A1B}' +   // light: the exact inverse
'.sw{padding:var(--s5) var(--pad-x) var(--s7);display:flex;justify-content:center;scroll-margin-top:7rem}' +
'.sw-card{position:relative;width:min(45rem,100%);min-height:34rem;box-sizing:border-box;overflow:hidden;' +
  'background:var(--sw-bg);color:var(--sw-ink);display:flex;flex-direction:column;align-items:center;justify-content:center;' +
  'padding:3.6rem 3.2rem 3.2rem;text-align:center;' +
  'box-shadow:0 0.5rem 1.25rem rgba(56,54,54,.10),0 2rem 3.5rem rgba(56,54,54,.18),0 3.5rem 6rem rgba(56,54,54,.12);' +
  'transition:background .45s var(--ease),width .45s var(--ease)}' +
'html:not(.mzlight) .sw-card{box-shadow:0 0 0 0.0625rem color-mix(in srgb,var(--sw-ink) 6%,transparent),0 2rem 5rem rgba(0,0,0,.5)}' +
'.sw.sw-done .sw-card{width:min(62rem,100%)}' +
'.sw-back{order:3;margin:1rem 0 0;background:none;border:none;padding:0.25rem;cursor:pointer;' +
  'color:color-mix(in srgb,var(--sw-ink) 80%,transparent);font-size:0.6875rem;letter-spacing:.2em;text-transform:uppercase}' +
'.sw-back:hover,.sw-x:hover{color:var(--sw-ink)}' +
'.sw-back[hidden],.sw-bar[hidden]{display:none}' +
'.sw-stage{order:1}' +
/* v456 (Faiz, 25 Sep): the five marks and Back sit UNDER the options, not over the card's shoulder,
   where the Back button used to crowd the "Question n of 5" line. */
'.sw-bar{order:2;margin:2.25rem 0 0;display:flex;gap:0.375rem}' +
'.sw-bar i{width:1.75rem;height:0.125rem;background:color-mix(in srgb,var(--sw-ink) 30%,transparent);transition:background .3s var(--ease)}' +
'.sw-bar i.on{background:var(--sw-ink)}' +
'.sw-stage{width:100%;display:flex;flex-direction:column;align-items:center;gap:1.25rem;' +
  'transition:opacity .26s var(--ease),transform .26s var(--ease)}' +
'.sw-out{opacity:0;transform:translateX(-1.5rem)}' +
'.sw-out-back{opacity:0;transform:translateX(1.5rem)}' +
'.sw-in{opacity:0;transform:translateX(1.5rem);transition:none}' +
'.sw-in-back{opacity:0;transform:translateX(-1.5rem);transition:none}' +
'.sw-eyebrow{margin:0;font-size:0.6875rem;letter-spacing:var(--track-label);text-transform:uppercase;color:color-mix(in srgb,var(--sw-ink) 80%,transparent)}' +
'.sw-h{margin:0;font-family:"Six Caps",sans-serif;font-weight:400;text-transform:uppercase;letter-spacing:.01em;' +
  'font-size:clamp(3rem,8vw,4.6rem);line-height:0.92;color:var(--sw-ink);outline:none}' +
'.sw-sub{margin:0;max-width:26rem;font-size:1.05rem;line-height:1.6;color:color-mix(in srgb,var(--sw-ink) 90%,transparent)}' +
'.sw-sub a{color:var(--sw-ink)}' +
'.sw-fine{margin:0;font-size:0.75rem;line-height:1.5;color:color-mix(in srgb,var(--sw-ink) 85%,transparent)}' +
'.sw-opts{display:flex;flex-direction:column;gap:0.625rem;width:100%;max-width:30rem}' +
'.sw-opt{font-family:var(--font-body);font-size:0.9375rem;line-height:1.5;text-align:left;padding:0.9rem 1.1rem;cursor:pointer;' +
  'background:transparent;color:var(--sw-ink);border:0.0625rem solid color-mix(in srgb,var(--sw-ink) 55%,transparent);' +
  'transition:background .18s ease,color .18s ease,transform .15s ease}' +
'.sw-opt:hover{background:color-mix(in srgb,var(--sw-ink) 12%,transparent);transform:translateY(-0.0625rem)}' +
'.sw-opt.is-on{background:var(--sw-ink);color:var(--sw-bg);border-color:var(--sw-ink)}' +
'.sw-card button:focus-visible,.sw-card a:focus-visible{outline:0.125rem solid var(--sw-ink);outline-offset:0.1875rem}' +
'.sw-card .sw-cta,.sw-card .sw-ghost{font-weight:800;letter-spacing:.28em;font-size:0.8125rem;text-align:center;cursor:pointer}' +
'.sw-card .sw-cta{background:var(--sw-ink);color:var(--sw-bg);border:0.125rem solid var(--sw-ink);' +
  'box-shadow:0 0.625rem 1.5rem rgba(0,0,0,.22),0 0 1.75rem color-mix(in srgb,var(--sw-ink) 30%,transparent)}' +
'.sw-card .sw-ghost{background:transparent;color:var(--sw-ink);border:0.125rem solid color-mix(in srgb,var(--sw-ink) 70%,transparent)}' +
'.sw-go{min-width:14rem}' +
'.sw-result{display:grid;grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr);gap:2.5rem;align-items:center;width:100%;text-align:left}' +
'.sw-bottle{margin:0;display:flex;justify-content:center}' +
'.sw-bottle img{max-width:100%;max-height:26rem;width:auto;height:auto;' +
  'filter:drop-shadow(0 1.5rem 2rem rgba(0,0,0,.28));animation:sw-rise .6s var(--ease) both}' +
'@keyframes sw-rise{from{opacity:0;transform:translateY(1.5rem) scale(.97)}to{opacity:1;transform:none}}' +
'.sw-rtext{display:flex;flex-direction:column;align-items:flex-start;gap:0.75rem;min-width:0}' +
'.sw-name{font-size:clamp(3.4rem,8vw,5.5rem)}' +
'.sw-role{margin:0;font-size:0.8125rem;font-weight:600;letter-spacing:var(--track-label);text-transform:uppercase;color:var(--sw-ink)}' +
'.sw-arc{margin:0;font-size:0.9375rem;line-height:1.6;color:var(--sw-ink)}' +
'.sw-arc span{font-size:0.625rem;letter-spacing:.2em;text-transform:uppercase;opacity:.7}' +
'.sw-arc b{font-weight:400;margin:0 0.35rem}' +
'.sw-price{margin:0.25rem 0 0;font-size:1.1rem;font-weight:700;letter-spacing:.12em;color:var(--sw-ink)}' +
'.sw-ctas{display:flex;flex-wrap:wrap;gap:0.625rem;margin-top:0.25rem}' +
'.sw-alt{display:grid;grid-template-columns:3rem minmax(0,1fr);column-gap:1rem;row-gap:0.75rem;align-items:center;width:100%;' +
  'margin-top:0.5rem;padding-top:1.1rem;border-top:0.0625rem solid color-mix(in srgb,var(--sw-ink) 25%,transparent);text-align:left}' +
'.sw-alt img{width:3rem;height:auto;grid-row:span 2}' +
'.sw-alt-t{display:flex;flex-direction:column;gap:0.2rem;min-width:0}' +
'.sw-alt em{font-style:normal;font-size:0.625rem;letter-spacing:.2em;text-transform:uppercase;opacity:.75}' +
'.sw-alt strong{font-size:1.05rem;font-weight:600;color:var(--sw-ink)}' +
'.sw-alt .sw-arc{font-size:0.8125rem;line-height:1.5}' +
'.sw-alt-p{font-size:0.8125rem;font-weight:700;letter-spacing:.12em}' +
'.sw-alt .cta{justify-self:start}' +
'.sw-disco{margin:0.25rem 0 0;padding:0;background:none;border:none;font:inherit;font-size:0.875rem;line-height:1.6;' +
  'color:var(--sw-ink);text-align:inherit;cursor:pointer;text-decoration:underline;text-decoration-color:color-mix(in srgb,var(--sw-ink) 50%,transparent);text-underline-offset:0.25em}' +
'.sw-disco:hover{text-decoration-color:var(--sw-ink)}' +
'.sw-retake{background:none;border:none;padding:0;cursor:pointer;color:color-mix(in srgb,var(--sw-ink) 80%,transparent);font-size:0.6875rem;' +
  'letter-spacing:.2em;text-transform:uppercase;text-decoration:underline;text-underline-offset:0.3em}' +
'.sw-retake:hover{color:var(--sw-ink)}' +
// overlay (MZFinder.open): sits above the game (z 300), scrolls on short phones
'.sw-ov{position:fixed;inset:0;z-index:310;overflow-y:auto;display:flex;padding:1rem;box-sizing:border-box;' +
  'background:color-mix(in srgb,#232325 42%,transparent);backdrop-filter:blur(0.4rem);-webkit-backdrop-filter:blur(0.4rem);' +
  'opacity:0;transition:opacity .3s ease}' +
'.sw-ov.sw-on{opacity:1}' +
'.sw-ov .sw{margin:auto;padding:0;width:100%}' +
'.sw-x{position:absolute;top:0.55rem;right:0.8rem;background:none;border:none;padding:0.25rem 0.4rem;cursor:pointer;' +
  'color:rgba(255,255,255,.8);font-size:1.6rem;line-height:1}' +
'@media (max-width:48rem){' +
  '.sw-card{padding:3.5rem 1.25rem 2rem;min-height:30rem}' +
  '.sw-result{grid-template-columns:1fr;gap:1.25rem;text-align:center}' +
  '.sw-rtext{align-items:center}' +
  '.sw-bottle img{max-height:15rem}' +
  '.sw-ctas{justify-content:center;width:100%}' +
  '.sw-ctas .cta,.sw-alt .cta{flex:1 1 100%;width:100%;justify-self:stretch}' +
  '.sw-alt .cta{grid-column:1/-1}' +
  '.sw-alt img{grid-row:auto}' +
  '.sw-ov{padding:0.5rem}' +
'}' +
'@media (prefers-reduced-motion:reduce){.sw-stage,.sw-card,.sw-opt,.sw-ov{transition:none}.sw-bottle img{animation:none}}';

  function injectCss() {
    if (document.getElementById('sw-css')) return;
    var s = document.createElement('style');
    s.id = 'sw-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function shop() { return window.MZ && window.MZ.products; }   // Shopify only (theme.liquid)
  function info(s) {
    var p = P[s], m = (shop() && shop()[s]) || {}, epos = EPOS.indexOf(s) > -1;
    var light = document.documentElement.classList.contains('mzlight');   // theme.js swaps later toggles
    return {
      slug: s, name: p[0], coll: p[1], role: p[2], arc: p[3], accent: p[5], epos: epos,
      price: m.price ? m.price + ' · ' + p[4].split(' · ')[1] : p[4],
      img: m.image || 'img/pp-' + s + (light ? '-light' : '') + '.png',
      url: (m.url || p[6]) + (epos ? '#preorder' : '')   // Epos: straight to the PDP's reserve form
    };
  }
  var SHELL = '<button type="button" class="sw-back zetta" hidden>&larr; Back</button>' +
    '<div class="sw-bar" aria-hidden="true" hidden></div>' +
    '<div class="sw-stage" aria-live="polite"></div>';

  // root = a .sw element holding .sw-card (page markup, or the overlay built by open())
  function mount(root, opts, done) {
    injectCss();
    var claim = opts.mode === 'claim';
    var card = root.querySelector('.sw-card'), stage = root.querySelector('.sw-stage'),
        back = root.querySelector('.sw-back'), bar = root.querySelector('.sw-bar'),
        step = -1, answers = [], busy = false;

    bar.innerHTML = Q.map(function () { return '<i></i>'; }).join('');

    function intro() {
      return '<p class="sw-eyebrow zetta">Scent finder: Find your Monzzaro</p>' +
        '<h2 class="sw-h">Five questions. One perfume.</h2>' +
        '<p class="sw-sub">Ten originals, three collections. Answer five questions and we will point you to the one that fits how you live and want to be remembered.</p>' +
        '<button class="cta zetta sw-cta sw-go" type="button">Begin</button>' +
        '<p class="sw-fine">No wrong answers. Just the beginning of a signature.</p>';
    }

    function question(i) {
      return '<p class="sw-eyebrow zetta">Question ' + (i + 1) + ' of ' + Q.length + '</p>' +
        '<h2 class="sw-h">' + esc(Q[i][1]) + '</h2>' +
        '<div class="sw-opts" role="group" aria-label="' + esc(Q[i][1]) + '">' +
        Q[i][2].map(function (o, j) {
          return '<button type="button" class="sw-opt' + (answers[i] === j ? ' is-on' : '') + '" data-i="' + j + '">' + esc(o[1]) + '</button>';
        }).join('') + '</div>';
    }

    function cta(p, r) {
      var cls = 'cta zetta ' + (r === 1 ? 'sw-cta' : 'sw-ghost'), data = ' data-pick="' + p.slug + '" data-rank="' + r + '"';
      return claim ? '<button type="button" class="' + cls + '"' + data + '>Choose this</button>'
        : '<a class="' + cls + '"' + data + ' href="' + esc(p.url) + '">' + (p.epos ? 'Preorder ' : 'Shop ') + esc(p.name) + '</a>';
    }
    function arc(p) {
      // One vocabulary on both cards: the alternative said Top/Base while the main said
      // Opens/Lands, which read as two different products (founder, 25 Sep).
      return '<span>Opens</span> ' + esc(p.arc[0]) +
        ' <b aria-hidden="true">→</b> <span>Lands</span> ' + esc(p.arc[1]);
    }

    function result() {
      var r = rank(answers), a = info(r[0]), b = info(r[1]);
      card.setAttribute('data-accent', a.accent);
      return '<div class="sw-result">' +
        '<figure class="sw-bottle"><img src="' + esc(a.img) + '" alt="' + esc(a.name) + '"></figure>' +
        '<div class="sw-rtext">' +
          '<p class="sw-eyebrow zetta">Your perfume · ' + a.coll + '</p>' +
          '<h2 class="sw-h sw-name">' + esc(a.name) + '</h2>' +
          '<p class="sw-role zetta">' + a.role + '</p>' +
          '<p class="sw-arc">' + arc(a) + '</p>' +
          '<p class="sw-price zetta">' + a.price + '</p>' +
          '<div class="sw-ctas">' + cta(a, 1) + '</div>' +
          '<div class="sw-alt">' +
            '<img src="' + esc(b.img) + '" alt="">' +
            '<div class="sw-alt-t"><em class="zetta">Or try · ' + b.coll + '</em>' +
              '<strong>' + esc(b.name) + '</strong>' +
              '<span class="sw-arc">' + arc(b) + '</span>' +
              '<span class="sw-alt-p zetta">' + b.price + '</span></div>' +
            cta(b, 2) +
          '</div>' +
          (claim ? '<button type="button" class="sw-disco">' + DISCO + '</button>'
                 : '<a class="sw-disco" href="' + (shop() ? '/products/discovery-set' : 'pdp-discovery-set.html') + '">' + DISCO + '</a>') +
          '<button type="button" class="sw-retake zetta">Retake the finder</button>' +
        '</div></div>';
    }

    function render(next, dir) {
      if (busy) return;
      busy = true;
      stage.classList.add(dir < 0 ? 'sw-out-back' : 'sw-out');
      setTimeout(function () {
        step = next;
        if (step < Q.length) card.removeAttribute('data-accent');
        stage.innerHTML = step < 0 ? intro() : step < Q.length ? question(step) : result();
        root.classList.toggle('sw-done', step >= Q.length);
        back.hidden = step < 0;
        [].forEach.call(bar.children, function (b, i) { b.classList.toggle('on', i < Math.min(step + 1, Q.length) && step >= 0); });
        bar.hidden = step < 0;
        stage.classList.remove('sw-out', 'sw-out-back');
        stage.classList.add(dir < 0 ? 'sw-in-back' : 'sw-in');
        void stage.offsetWidth;
        stage.classList.remove('sw-in', 'sw-in-back');
        var h = stage.querySelector('.sw-h');
        if (h && step >= 0) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        // phones: the card can start above the fold after a tall step; bring its top back
        if (step >= 0 && card.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
        var cta = stage.querySelector('.sw-cta');
        if (cta && window.mzSpecularAttach) window.mzSpecularAttach(cta);
        busy = false;
      }, reduce ? 0 : 260);
    }

    stage.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-pick]');
      if (pick) {
        if (opts.onPick) opts.onPick(pick.dataset.pick, +pick.dataset.rank);
        if (claim) done();
        return;
      }
      if (e.target.closest('.sw-disco')) {
        if (opts.onDiscovery) opts.onDiscovery();
        if (claim) done();
        return;
      }
      var t = e.target.closest('button');
      if (!t) return;
      if (t.classList.contains('sw-go')) return render(0, 1);
      if (t.classList.contains('sw-retake')) { answers = []; return render(-1, -1); }
      if (t.classList.contains('sw-opt')) {
        if (busy) return;
        answers[step] = +t.dataset.i;
        answers.length = step + 1;
        [].forEach.call(t.parentNode.children, function (b) { b.classList.toggle('is-on', b === t); });
        setTimeout(function () { render(step + 1, 1); }, reduce ? 0 : 180);
      }
    });
    back.addEventListener('click', function () {
      render(step >= Q.length ? Q.length - 1 : step - 1, -1);
    });

    render(-1, 1);
  }

  // overlay mount for the house game (or anything else): returns { close }
  function open(opts) {
    opts = opts || {};
    injectCss();
    var ov = document.createElement('div'), prevOverflow = document.documentElement.style.overflow;
    ov.className = 'sw-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Scent finder');
    ov.innerHTML = '<section class="sw"><div class="sw-card"><button type="button" class="sw-x" aria-label="Close">×</button>' + SHELL + '</div></section>';
    function close() {
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = prevOverflow;
      ov.remove();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('.sw-x')) close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(ov);
    document.documentElement.style.overflow = 'hidden';
    mount(ov.querySelector('.sw'), opts, close);
    requestAnimationFrame(function () { ov.classList.add('sw-on'); });
    setTimeout(function () { var go = ov.querySelector('.sw-go'); if (go) go.focus({ preventScroll: true }); }, reduce ? 0 : 300);
    return { close: close };
  }
  window.MZFinder = { open: open, info: info, slugs: SLUGS };   // info + slugs: the game's bottle grid

  var page = document.getElementById('sw');
  if (page) mount(page, {}, function () {});
})();
